import type { AppRouter } from "@klarify/api";
import { env } from "@klarify/env";
import { hasWindow } from "@klarify/utilities";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import superjson from "superjson";

export const transformer = superjson;

function getBaseUrl() {
	if (hasWindow()) {
		return "";
	}
	if (env.VERCEL_URL) {
		return `https://${env.VERCEL_URL}`;
	}
	return `http://localhost:${env.PORT ?? 3000}`;
}

export function getUrl() {
	return `${getBaseUrl()}/api/trpc`;
}

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
